import { CourseMarkdown } from "@/components/storyboard/CourseMarkdown";
import ContentBlock from "@/components/storyboard/ContentBlock";
import { learningObjectiveListComponents } from "@/components/storyboard/text/learningObjectiveListComponents";
import type { TextIntroBodyData } from "@/types/storyboard";

interface Props {
  data: TextIntroBodyData;
  title: string;
}

/**
 * Capability assertions for a lesson — accent surface matching summary/info blocks.
 */
export const TextLearningObjectiveAssertion = ({ data, title }: Props) => {
  const heading = data.title || title || "Lernzielaussage";

  return (
    <ContentBlock title={heading} tone="emphasis">
      {data.introduction && (
        <div className="prose mb-4 max-w-full font-semibold text-primary">
          <CourseMarkdown>{data.introduction}</CourseMarkdown>
        </div>
      )}
      {data.text && (
        <CourseMarkdown components={learningObjectiveListComponents}>
          {data.text}
        </CourseMarkdown>
      )}
    </ContentBlock>
  );
};
